import * as React from 'react'

import { LOCIZE_NAMESPACE as NAMESPACE } from 'main/common'
import { useTranslation } from 'react-i18next'
import { FilterControl } from '../common'
import IFullSearchProps from '../types'
import FilterForm from './FilterForm'

export default function SpokenLanguageFilter(props: IFullSearchProps) {
  const {
    filters,
    displayForm,
    palette,
    onChangeFilters,
    onRequestCloseForm,
    onRequestDisplayForm,
  } = props

  const { t: translate } = useTranslation(NAMESPACE)

  function t(suffix: string): string {
    return translate(`FILTERBAR-SPOKEN-LANGUAGE-${suffix}`)
  }
  function c(suffix: string): string {
    return translate(`COMMON-${suffix}`)
  }

  function locized(lang: string): string {
    return c(lang.toUpperCase())
  }

  function label(langs: string[]): string {
    if (langs.length > 0) {
      return langs.map(locized).join(', ')
    }
    return t('LABEL')
  }

  const selected = filters.selectedSpokenLanguages.sort()
  const isActive = !!selected.length
  const displayLabel = label(selected)

  return (
    <div>
      <FilterControl
        isActive={isActive}
        label={displayLabel}
        displayForm={displayForm}
        palette={palette}
        onRequestCloseForm={onRequestCloseForm}
        onRequestDisplayForm={onRequestDisplayForm}
        filterForm={
          <FilterForm
            filters={filters}
            onChangeFilters={onChangeFilters}
            onRequestCloseForm={onRequestCloseForm}
          />
        }
      />
    </div>
  )
}
